module.exports = __webpack_public_path__ + "img/ico-burger.f36c5bc6.svg";